var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('section',{staticClass:"loading wh100 fixed top0 left0 z999999 flex-center"},[_c('div',{staticClass:"lds-dual-ring"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }